import React, { Component } from "react";
import Joyride from "react-joyride";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Divider,
  Button,
  CardActions,
  CardHeader,
  CardMedia,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Tooltip,
} from "@mui/material";
import ResetDate from "../images/resetdate.png";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArticleIcon from "@mui/icons-material/Article";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReportIcon from "@mui/icons-material/Report";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AddIcon from "@mui/icons-material/Add"; // Plus icon
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { fetchCIDetail, fetchDashboard } from "./API";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DescriptionIcon from "@mui/icons-material/Description";
import BookIcon from "@mui/icons-material/Book";
import { useNavigate } from "react-router-dom";
import income from "../images/income.png";
import expenses from "../images/expenses .png";
import sale from "../images/sale.png";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Aos from "aos";
import "./Dashboard2.css";
import "aos/dist/aos.css";

import { useEffect } from "react";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCReduxData from "../HOC/HOCReduxData";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

// ES6
// var ReactCSSTransitionGroup = require('react-transition-group');
import Date from "./date";
import moment from "moment";

import { FaRupeeSign } from "react-icons/fa";
import { TbReceiptRupee } from "react-icons/tb";
import { MdOutlinePayment } from "react-icons/md";
import { GiFarmer } from "react-icons/gi";
import { MdOutlineShoppingCart } from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";
import Subscription from "./Subscription";
import { fetchDashboardDetail } from "./API";
import {
  get_YMD_from_DMY,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import { WarningAmber } from "@mui/icons-material";
class Dashboard2 extends Component {
  // componentDidMount() {
  //   console.log("Dialog mounted");
  // }
  componentDidMount() {
    // console.log("Dialog mounted"); // Ensure it gets mounted

    document.title = "RiTe Account : Dashboard";
    this.props.setActiveMenu("Dashboard");

    this.getInfo();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  constructor(props) {
    super(props);

    //   useEffect(() => {
    //     Aos.init({
    //       duration: 1000,
    //       easing: "ease-in-out",
    //       once: true,
    //     });
    //   }, []);

    this.state = {
      formData: {
        txtCI: "",
        txtProductKey: "",
        txtlicensed: "",
        txtfromdate: "",
        txttodate: "",
      },
      subscriptionDueDate: "",
      dataLoadStatus: true,
      openDialog: false,
      showFarmerBillGuide: false,
      date: [
        { name: "Today" },
        { name: "This Month" },
        {
          name: "From Date - To Date",
        },
      ],
      services: [
        {
          status: "Active",
          plan: "SSD Shared Hosting - SSD Standard Plan",
          domain: "apcmkalavad.in",
        },
        {
          status: "Active",
          plan: "SSD Shared Hosting - SSD Standard Plan",
          domain: "wayonmarketing.com",
        },
        {
          status: "Active",
          plan: "Cloud Hosting - USA - Business Cloud - USA",
          domain: "ravitechworld.com",
        },
        {
          status: "Active",
          plan: "Cloud Hosting - USA - Business Cloud - USA",
          domain: "sahakarexports.com",
        },
      ],
      data: [
        {
          id: 1,
          tcolor: "#808080",
          color: "#d6effc",
          Color: "#D32F2F",
          title: "Sales",
          amount: " ₹ 3,766",
          subtitle: "Sales Today: 250",
          module: "Sales",
          //   color: "#e3f2fd",
          txtdate: "Today",
          icon: <FaRupeeSign style={{ fontSize: "50px", color: "#808080" }} />,
          route: "/SalesList",
          route1: "/Salesnew",
          route2: "/SalesReport",
          route3: "/BookReport/:Customer",
          t: "Sales List",
          t1: "Sales Entry",
          t2: "Sales Report",
          t3: "Customer Book Report",
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          PendingInvoice: 0,

          TotalInvoice: 0,
          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          id: 2,
          tcolor: "#808080",
          color: "#d6effc",
          Color: "#009688 ",

          txtdate: "Today",
          title: "Purchase",
          amount: " ₹ 652",
          subtitle: "Purchase Today: 40",
          module: "Purchase",
          //   color: "#fffde7",

          icon: (
            <MdOutlineShoppingCart
              style={{ fontSize: "50px", color: "#808080" }}
            />
          ),
          route: "/PurchaseList",
          route1: "/Purchasenew",
          route2: "/PurchaseReport",
          route3: "/BookReport/:Supplier",
          t: "Purchase List",
          t1: "Purchase Entry",
          t2: "Purchase Report",
          t3: "Supplier Book Report",
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          PendingInvoice: 0,
          TotalInvoice: 0,
          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          id: 3,
          tcolor: "#808080",
          color: "#e8f5e9",
          Color: "#FFA000",

          txtdate: "Today",
          title: "Receipt ",
          amount: "  ₹ 21,156",
          subtitle: "Recepit Today: 310",
          module: "Receipt",
          //   color: "#e8f5e9 ",
          route: "/ReceiptList",
          route1: "/ReceiptEntry",
          t: "Receipt List",
          t1: "Receipt Entry",
          icon: (
            <TbReceiptRupee style={{ fontSize: "50px", color: "#808080" }} />
          ),
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          ARDOpen: true,
          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          tcolor: "#808080",
          color: "#e8f5e9",
          Color: "#4CAF50",

          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),

          id: 4,
          txtdate: "Today",
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          title: "Payment",
          amount: "₹ 38",
          subtitle: "Payment Today: 2",
          module: "Payment",
          //   color: "#ffebee",

          route: "/PaymentList",
          route1: "/PaymentEntry",
          ARDOpen: true,
          t: "Payment List",
          t1: "Payment Entry",
          icon: (
            <MdOutlinePayment style={{ fontSize: "50px", color: "#808080" }} />
          ),
        },
        {
          id: 5,
          tcolor: "#808080",
          color: "#d6effc",
          Color: "#800080",
          title: "ખેડૂત બિલ",
          amount: " ₹ 3,766",
          subtitle: "Sales Today: 250",
          module: "ખેડૂતબિલ",

          // color: "#e3f2fd",
          txtdate: "Today",
          icon: <GiFarmer style={{ fontSize: "50px", color: "#808080" }} />,
          route: "/FarmerBillList",
          route1: "/FarmerBillEntry",
          route2: "/KhedutBillPrint",
          t: "ખેડૂત બિલ યાદી",
          t1: "ખેડૂત બિલ એન્ટ્રી",
          t2: "ખેડૂત બિલ પ્રિન્ટ",
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          PendingInvoice: 0,

          TotalInvoice: 0,
          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          id: 6,
          tcolor: "#808080",
          color: "#d6effc",
          Color: "#1976d2",
          title: "Trip",
          amount: " ₹ 3,766",
          subtitle: "Trip Today: 250",
          module: "Trip",
          //   color: "#e3f2fd",
          txtdate: "Today",
          icon: <DriveEtaIcon style={{ fontSize: "50px", color: "#808080" }} />,
          route: "/TripList",
          route1: "/TripEntry",
          route2: "/BookReport/:Supplier",
          route3: "/BookReport/:Customer",
          t: "Trip List",
          t1: "Trip Entry",
          t2: "Supplier Book Report",
          t3: "Customer Book Report",
          Today: "",
          ThisMonth: "",
          FromDateToDate: "",
          PendingInvoice: 0,

          TotalInvoice: 0,
          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
      ],
      reports: [
        {
          title: "Customer Book",
          icon: <BookIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/BookReport/Customer",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
        {
          title: "Supplier Book",
          icon: <PeopleAltIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/BookReport/Supplier",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
        {
          title: "Day Book",
          icon: <AssignmentIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/DayBookReport",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },

        {
          title: "GST Report",
          icon: <DescriptionIcon sx={{ fontSize: 40, color: "black" }} />,
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
      ],
    };
  }
  steps = [
    {
      target: ".first-element",
      content: "ખેડૂત બિલ યાદી માં જવા માટે",
    },
    {
      target: ".second-element",
      content: "ખેડૂત બિલ એન્ટ્રી માં જવા માટે",
    },
  ];

  onFormLoad = (changedCard = null) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const selectedCard = changedCard || this.state.data[0];
      // console.log("selectedCard", selectedCard);

      let typeList = [];
      if (changedCard) {
        typeList = [changedCard.module];
      } else {
        typeList =
          // [
          //   "Sales",
          //   "Purchase",
          //   "Receipt",
          //   "Payment",
          //   "Trip",
          //   "ખેડૂતબિલ",
          // ];
          this.state.data
            .filter((item) => this.props.userPrivilege[item.module])
            .map((item) => item.module);
      }
      if (typeList.length > 0) {
        const reqData = {
          Op: "GetDashboardDetail",
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          Type: typeList,
          filterType: selectedCard.txtdate,
          fromDate: moment(selectedCard.dtpFromDate, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          toDate: moment(selectedCard.dtpToDate, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
        };

        fetchDashboardDetail(reqData)
          .then((res) => {
            const updatedData = this.state.data.map((item) => {
              const moduleKeyMap = {
                Sales: "SalesData",
                Purchase: "PurchaseData",
                Receipt: "ReceiptData",
                Payment: "PaymentData",
                Trip: "TripData",
                ખેડૂતબિલ: "FarmerData",
              };
              const dataKey = moduleKeyMap[item.module];
              const moduleData = res.data?.[dataKey];

              if (moduleData) {
                const updatedItem = { ...item };

                let value = "";
                switch (dataKey) {
                  case "SalesData":
                    value = moduleData.total_sales;
                    break;
                  case "PurchaseData":
                    value = moduleData.total_purchase;
                    break;
                  case "ReceiptData":
                    value = moduleData.total_income;
                    break;
                  case "PaymentData":
                    value = moduleData.total_payment;
                    break;
                  case "TripData":
                    value = moduleData.total_trip;
                    break;
                  case "FarmerData":
                    value = moduleData.total_farmer;
                    break;
                }

                const formattedValue = isNaN(value)
                  ? value
                  : `₹ ${parseFloat(value)}`;

                switch (item.txtdate) {
                  case "Today":
                    updatedItem.Today = formattedValue;
                    break;
                  case "This Month":
                    updatedItem.ThisMonth = formattedValue;
                    break;
                  case "From Date - To Date":
                    updatedItem.FromDateToDate = formattedValue;
                    break;
                }

                return updatedItem;
              }

              return item;
            });

            this.setState({ data: updatedData, dataLoadStatus: true });
            this.props.closeUpdateProcessing();
          })
          .catch((error) => {
            console.error("Error in onFormLoad:", error);
            this.props.updateProcessing("error", "Failed to load data");
          });
      }
    });
  };

  handleCardClick = (card) => {
    this.onFormLoad(card);
  };

  handleNavigate = (route) => {
    this.props.navigate(route);
  };

  handleNavigateWithOpenARD = (route) => {
    let path = route.startsWith("/") ? route.slice(1) : route;
    localStorage.setItem("openARD", true);
    this.props.navigateTo(path, {
      ARD: true,
    });
  };
  calculateSubtitle = (item) => {
    const currentDate = item.txtdate || this.state.txtdate;

    const getSubtitleContent = () => {
      switch (currentDate) {
        case "Today":
          return `${item.Today}`;

        case "This Month":
          return `  ${item.ThisMonth}`;

        case "From Date - To Date":
          const fromDate = item.dtpFromDate
            ? ` ${item.dtpFromDate}`
            : "From Date";
          const toDate = item.dtpToDate ? `${item.dtpToDate}` : "To Date";
          return ` ${item.FromDateToDate}`;

        default:
          return "";
      }
    };

    return currentDate === "From Date - To Date" ? (
      <span
        style={{
          cursor: "pointer",
        }}
        onClick={() => this.openDialog(item)}
      >
        {getSubtitleContent()}
      </span>
    ) : (
      getSubtitleContent()
    );
  };
  calculateDate = (item) => {
    const currentDate = item.txtdate || this.state.txtdate;

    const getSubtitleContent = () => {
      switch (currentDate) {
        case "Today":
          return moment().format("DD-MM-YYYY");

        case "This Month":
          return moment().format("MMMM");
        case "From Date - To Date":
          const fromDate = item.dtpFromDate
            ? ` ${item.dtpFromDate}`
            : "From Date";
          const toDate = item.dtpToDate ? `${item.dtpToDate}` : "To Date";
          return `${fromDate} To ${toDate}`;

        default:
          return "";
      }
    };

    return currentDate === "From Date - To Date" ? (
      <span
        style={{
          cursor: "pointer",
        }}
        onClick={() => this.openDialog(item)}
      >
        {getSubtitleContent()}
      </span>
    ) : (
      getSubtitleContent()
    );
  };
  setFromToDate = (id, fromDate, toDate) => {
    this.setState((prevState) => ({
      data: prevState.data.map((item) =>
        item.id === id
          ? { ...item, dtpFromDate: fromDate, dtpToDate: toDate }
          : item
      ),
    }));
  };

  // setfrom_todate = (reset = false) => {
  //   setlocalstoragedate(
  //     "Dashboard2",
  //     this.state.formData.dtpFromDate,
  //     this.state.formData.dtpToDate,
  //     reset
  //   );
  //   if (reset) {
  //     window.location.reload();
  //     this.onFormLoad();
  //   }
  // };

  // onFormLoad = () => {
  //   const { fromdate, todate } = getlocalstoragedate("Dashboard2");
  //   let dtpFromDate = fromdate,
  //     dtpToDate = todate;
  //   // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
  //   //   dtpToDate = get_YMD_from_SYS(new Date());
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //         dtpFromDate,
  //         dtpToDate,
  //       },
  //     },
  //     () => {
  //       this.getInfo();
  //     }
  //   );
  // };
  // validateDate = () => {
  //   let result = false;
  //   if (this.state.formData.dtpFromDate.length <= 0) {
  //     this.props.toastErrorMsg("Enter Date", "dtpFromDate");
  //   } else if (
  //     validatedate_min_max(
  //       this.state.formData.dtpFromDate,
  //       "dtpFromDate",
  //       this.props.toastErrorMsg
  //     ) == false
  //   ) {
  //     return result;
  //   } else if (this.state.formData.dtpToDate.length <= 0) {
  //     this.props.toastErrorMsg("Enter Date", "dtpToDate");
  //   } else if (
  //     validatedate_min_max(
  //       this.state.formData.dtpToDate,
  //       "dtpToDate",
  //       this.props.toastErrorMsg
  //     ) == false
  //   ) {
  //     return result;
  //   } else {
  //     result = true;
  //   }
  //   return result;
  // };

  // getInfo = () => {
  //   if (this.validateDate()) {
  //     let dataLoadStatus = false;
  //     this.setState({ dataLoadStatus }, () => {
  //       const reqData = {
  //         Op: "PurchaseList",
  //         bint_acyear: localStorage.getItem("ACY"),
  //         bint_acid: localStorage.getItem("acid"),
  //         dat_fromdate: this.state.formData.dtpFromDate,
  //         dat_todate: this.state.formData.dtpToDate,
  //       };
  //     });
  //   }
  // };
  handleOnChange = (e, id) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        data: prevState.data.map((item) =>
          item.id === id ? { ...item, txtdate: value } : item
        ),
      }),
      () => {
        const changedCard = this.state.data.find((item) => item.id === id);
        if (changedCard) {
          this.onFormLoad(changedCard);
        }
      }
    );

    // txtdate: newDate,
  };
  handleDateChange = (name, value, id) => {
    const formattedDate = moment(value).format("DD-MM-YYYY");
    // console.log("formattedDate", formattedDate);
    // console.log("name", name);

    this.setState(
      (prevState) => ({
        data: prevState.data.map((item) =>
          item.id === id ? { ...item, [name]: formattedDate } : item
        ),
      }),
      () => {
        console.log("data", this.state.data);
      }
    );
  };

  openDialog = (item) => {
    this.setState({ ARD: null }, () => {
      // console.log("Item dates:", item.dtpFromDate, item.dtpToDate);

      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <Date
              handleDateChange={this.handleDateChange}
              id={item.id}
              dtpFromDate={moment(item.dtpFromDate, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              )}
              dtpToDate={moment(item.dtpToDate, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              )}
            />
          }
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            const changedCard = this.state.data.find(
              (rowData) => rowData.id === item.id
            );
            if (changedCard) {
              this.onFormLoad(changedCard);
            }
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getInfo = () => {
    const reqData = {
      Op: "SubscriptionListFrmCI",
      bint_ci: localStorage.getItem("CI"),
    };
    fetchCIDetail(reqData)
      .then((res) => {
        let SubscriptionList = res.data.SubscriptionListFrmCI[0];
        this.setState({
          formData: {
            txtCI: SubscriptionList.vac_citype,
            txtProductKey: "9QE3B1J0271828C2B0R0",
            txtlicensed: SubscriptionList.vac_ciname,
            txtfromdate: "04-Dec-2023",
            txttodate: SubscriptionList.dat_subenddate,
          },
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
  };

  getDaysLeft = () => {
    const parseCustomDate = (str) => {
      if (!str || typeof str !== "string") return null;

      const [day, monthStr, year] = str.split("-");
      if (!day || !monthStr || !year) return null;

      // Normalize month string (e.g., "Dec" => "December")
      const monthMap = {
        Jan: "January",
        Feb: "February",
        Mar: "March",
        Apr: "April",
        May: "May",
        Jun: "June",
        Jul: "July",
        Aug: "August",
        Sep: "September",
        Oct: "October",
        Nov: "November",
        Dec: "December",
      };

      const normalizedMonthKey =
        monthStr.charAt(0).toUpperCase() + monthStr.slice(1, 3).toLowerCase();
      const fullMonth = monthMap[normalizedMonthKey];

      if (!fullMonth) return null;

      const dateStr = `${fullMonth} ${day}, ${year}`; // e.g., "May 31, 2025"
      const dateObj = new window.Date(dateStr);

      return isNaN(dateObj) ? null : dateObj;
    };

    const today = new window.Date();
    const dueDate = parseCustomDate(this.state.formData.txttodate); // make sure this field has correct value

    if (!dueDate) {
      console.error("Invalid due date format:", this.state.formData.txttodate);
      return "-";
    }

    // Reset time for date-only comparison
    today.setHours(0, 0, 0, 0);
    dueDate.setHours(0, 0, 0, 0);

    const timeDiff = dueDate.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    return isNaN(daysLeft) ? "-" : daysLeft;
  };

  openArd = () => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          alertMessage={
            <Subscription
              Days={this.getDaysLeft()}
              CI_Type={this.state.formData.txtCI}
              CI_Name={this.state.formData.txtlicensed}
              DueDate={this.state.formData.txttodate}
              FormDate={this.state.formData.txtfromdate}
              ProductKey={this.state.formData.txtProductKey}
            />
          }
          labelDisagree="Close"
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  render() {
    const { date } = this.state;
    return (
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid container justifyContent="flex-start" spacing={2}>
          <Tooltip title="Show Farmer Bill Guide" arrow>
            <IconButton
              onClick={() => this.setState({ showFarmerBillGuide: true })}
              sx={{
                position: "fixed",
                top: 70,
                right: 5,
                zIndex: 100,
                backgroundColor: "#1976d2",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
                boxShadow: 3,
              }}
            >
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {this.state.data.map(
            (item, index) =>
              this.props.userPrivilege[item.module] && (
                <Grid item key={item.id}>
                  <Card
                    key={item.id}
                    sx={{
                      color: "black",
                      height: "260px",
                      width: "360px",
                      padding: "2",
                      boxShadow: 2,
                      // borderRight: item.id === 4 ? "none" : "2px solid black",
                      transition:
                        "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        boxShadow: 4,
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    {" "}
                    <Grid item>
                      <CardHeader
                        avatar={
                          <Box>
                            {" "}
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <Grid item>
                                <Typography
                                  variant="h6"
                                  style={{
                                    color: item.tcolor,
                                    fontWeight: "600",
                                    letterSpacing: 0,
                                  }}
                                  sx={{
                                    padding: "0 15px",
                                  }}
                                >
                                  {item.title}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <CardActions
                                  sx={{
                                    padding: "0",
                                  }}
                                >
                                  <IconButton
                                    className={
                                      item.id === 5
                                        ? "farmer-bill-second-element"
                                        : ""
                                    }
                                    sx={{
                                      cursor: "pointer",
                                      transition: "transform 0.3s ease-in-out",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1.1)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                    }}
                                    onClick={() => {
                                      item.ARDOpen
                                        ? this.handleNavigateWithOpenARD(
                                            item.route
                                          )
                                        : this.handleNavigate(item.route1);
                                    }}
                                    title={item.t1}
                                  >
                                    <AddCircleIcon
                                      sx={{ color: item.tcolor }}
                                    />
                                  </IconButton>

                                  <IconButton
                                    className={
                                      item.id === 5
                                        ? "farmer-bill-first-element"
                                        : ""
                                    }
                                    sx={{
                                      cursor: "pointer",
                                      transition: "transform 0.3s ease-in-out",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1.1)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                    }}
                                    onClick={() =>
                                      this.handleNavigate(item.route)
                                    }
                                    title={item.t}
                                  >
                                    <ArticleIcon sx={{ color: item.tcolor }} />
                                  </IconButton>

                                  {(item.id === 1 ||
                                    item.id === 2 ||
                                    item.id === 5 ||
                                    item.id === 6) && (
                                    <>
                                      <IconButton
                                        sx={{
                                          cursor: "pointer",
                                          transition:
                                            "transform 0.3s ease-in-out",
                                        }}
                                        onMouseOver={(e) => {
                                          e.currentTarget.style.transform =
                                            "scale(1.1)";
                                        }}
                                        onMouseOut={(e) => {
                                          e.currentTarget.style.transform =
                                            "scale(1)";
                                        }}
                                        onClick={() =>
                                          this.handleNavigate(item.route2)
                                        }
                                        title={item.t2}
                                      >
                                        <BookIcon sx={{ color: item.tcolor }} />
                                      </IconButton>

                                      {(item.id === 1 ||
                                        item.id === 2 ||
                                        item.id === 6) && (
                                        <IconButton
                                          sx={{
                                            cursor: "pointer",
                                            transition:
                                              "transform 0.3s ease-in-out",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1.1)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1)";
                                          }}
                                          onClick={() =>
                                            this.handleNavigate(item.route3)
                                          }
                                          title={item.t3}
                                        >
                                          <DescriptionIcon
                                            sx={{ color: item.tcolor }}
                                          />
                                        </IconButton>
                                      )}
                                    </>
                                  )}

                                  {this.state.showFarmerBillGuide &&
                                    item.id === 5 && (
                                      <Joyride
                                        steps={[
                                          {
                                            target:
                                              ".farmer-bill-first-element",
                                            content:
                                              "ખેડૂત બિલ યાદી માં જવા માટે",
                                            disableBeacon: true,
                                          },
                                          {
                                            target:
                                              ".farmer-bill-second-element",
                                            content:
                                              "ખેડૂત બિલ એન્ટ્રી માં જવા માટે",
                                            disableBeacon: true,
                                          },
                                        ]}
                                        continuous={true}
                                        showSkipButton={true}
                                        hideCloseButton={false}
                                        disableOverlayClose={true}
                                        styles={{
                                          options: {
                                            zIndex: 10000,
                                          },
                                        }}
                                        callback={(data) => {
                                          if (
                                            data.action === "close" ||
                                            data.action === "skip" ||
                                            data.status === "finished" ||
                                            (data.action === "next" &&
                                              data.index === 2)
                                          ) {
                                            this.setState({
                                              showFarmerBillGuide: false,
                                            });
                                          }
                                        }}
                                      />
                                    )}
                                </CardActions>
                              </Grid>
                            </Box>
                            <Divider
                              sx={{
                                margin: "8px 16px",
                                height: "3px",
                                backgroundColor: item.Color,
                                width: "300px",
                              }}
                            />
                          </Box>
                        }
                      />

                      <CardContent
                        sx={{
                          padding: "0 16px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            marginLeft: "15px",
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{ fontWeight: "bold", color: "#1565C0" }}
                          >
                            {this.calculateSubtitle(item)}
                          </Typography>
                          <Grid
                            sx={{
                              marginRight: "23px",
                            }}
                          >
                            {item.icon}
                          </Grid>
                        </Box>
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-start" // Align items to the left
                        >
                          <Grid item>
                            <Grid
                              container
                              direction="column"
                              alignItems="flex-start" // Align items to the left
                              marginLeft={"15px"}
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="center" // Keep items aligned horizontally in a row
                              >
                                <Grid item>
                                  <CtCmb
                                    // id="date"
                                    id={`date-${item.id}`}
                                    label=""
                                    items={date}
                                    value={item.txtdate}
                                    handleOnChange={(e) => {
                                      console.log(
                                        "Handling change for item:",
                                        item
                                      ); // Debugging
                                      this.handleOnChange(e, item.id);
                                    }}
                                    width={180}
                                    colID="name"
                                  />
                                </Grid>
                                <Grid item marginTop={"15px"}>
                                  {item.txtdate === "From Date - To Date" && (
                                    <IconButton
                                      onClick={() => this.openDialog(item)}
                                    >
                                      <FaRegCalendarAlt
                                        style={{
                                          fontSize: "30px",
                                          color: "#808080",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid item>
                                <p>{this.calculateDate(item)}</p>
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* <Grid item>{item.id === 1 || item.id === 2 ? (
                      <>
                      <Box
  sx={{
    display: "flex",
    flexDirection: "column", // Stack items vertically
    margin: "10px",
  }}
                          >
                            
  <Box sx={{ marginBottom: "10px" }}>
    <Typography sx={{ fontSize: "15px" }}>Total Invoice</Typography>
    <Typography sx={{ fontSize: "15px", fontWeight: "300" }}>
      {item.PendingInvoice}
    </Typography>
  </Box>

  <Box>
    <Typography sx={{ fontSize: "15px" }}> Pending Invoice</Typography>
    <Typography sx={{ fontSize: "15px", fontWeight: "600" }}>
      {item.TotalInvoice}
    </Typography>
  </Box>
</Box>


                      </>) : (
  ""
)}
                        </Grid> */}
                        </Grid>
                      </CardContent>
                    </Grid>
                  </Card>
                </Grid>
              )
          )}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="right"
          spacing={0}
          marginTop={30}
        >
          <Grid item>
            {/* <Box
              onClick={this.openArd}
              sx={{
                position: "fixed",
                bottom: 20,
                right: 5,
                zIndex: 100,
                backgroundColor: "#fad2cd",
                cursor: "pointer",
                color: "#fc3419",
                padding: "6px",
                borderRadius: "4px",
                borderLeft: "3px solid #fc3419",
              }}
            > */}

            <Box
              onClick={this.openArd}
              sx={{
                backgroundColor: "#ffe5e5",
                border: "1px solid red",
                color: "red",
                padding: "8px 12px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                fontWeight: "bold",
                fontSize: "14px",
                position: "fixed",
                bottom: "10px",
                right: "10px",
                zIndex: 999,
                cursor: "pointer",
              }}
            >
              <WarningAmber sx={{ marginRight: "6px" }} />
              {this.getDaysLeft() <= 0 ? (
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color="error" // red text
                >
                  Subscription Over
                </Typography>
              ) : (
                <Typography variant="subtitle1" fontWeight="bold">
                  Due Subscription - {this.getDaysLeft()} Days Left
                </Typography>
              )}
              {/* <Typography style={{ fontSize: "14px" }}>
                Show More Detaills
              </Typography> */}
            </Box>
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </Grid>
    );
  }
}
export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps
  )(HOCVerifyIsUser(HOCReduxData(HoCtToastContainer(Dashboard2))))
);
